import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import GameBackground from '../game/GameBackground';
import GameHUD from '../ui/GameHUD';
import SelectScreen from './SelectScreen';
import TripMazeGame from '../game/TripMazeGame';
import gameData from '../gameData';
import GameOverPopup from '../ui/GameOverPopup';
import GameCompletePopup from '../ui/GameCompletePopup';

export default class Game extends Phaser.Scene {
  static get KEY() { return 'Game'; }

  create() {
    GameBackground.instance.switchBg('level',false);
    this.hud = new GameHUD(this);
    this.hud.on('UI_CLICK', this.handleUiInput, this);

    this.mazeGame = new TripMazeGame(this);

    this.add.existing(this.mazeGame);
    this.add.existing(this.hud);

    this.startGameScreen();
  }

  handleUiInput (e) {
    if (e === 'menu') {
      this.time.delayedCall(100, this.cleanUp, null, this);
    }
    else if (e === 'skip') {
      this.mazeGame.skipDestinationSound();
    }
    else {
      // restart button
      this.mazeGame.startLevel(null, true);
    }
  }

  startGameScreen () {
    this.mazeGame.initGame(gameData.allLevels[gameData.curLevelIndex]);
    this.mazeGame.on('LEVEL_COMPLETE', this.handleLevelComplete, this);
    this.mazeGame.on('GAME_END', this.handleGameOver, this);
    this.mazeGame.once('GAME_WON', this.handleGameComplete, this);
    this.mazeGame.on('TOGGLE_RETURN_SKIP', () => this.hud.toggleReturnSkip('skip'));
    this.mazeGame.on('TOGGLE_HUD', toggle => this.toggleHUD(toggle));
  }

  toggleHUD(toggle) {
    toggle ? this.hud.enableBtns() : this.hud.disableBtns();
  }

  handleLevelComplete (e) {
    this.hud.toggleReturnSkip('return');
    this.showLevelResults(e._newBest, e._timeComplete);
  }

  showLevelResults (isNewBest,newTime) {
    const levelData = gameData.allLevels[gameData.curLevelIndex];

    this.hud.showResults(levelData,isNewBest,newTime);
    this.hud.once('RESULTS_DISMISSED', this.handleResultsDismissed, this);
  }

  handleResultsDismissed (e) {
    if (e === 'same level' || !gameData.gameComplete) {
      this.mazeGame.resumeGame(e);
    }
    else {
      this.finishGame();
    }
  }

  finishGame () {
    this.cleanUp();
  }

  handleGameOver () {
    this.hud.disableBtns();
    const gameOverPopUp = new GameOverPopup(this);
    this.add.existing(gameOverPopUp);
    gameOverPopUp.once('END_DIALOG', this.handleGameOverDismissed, this);
  }

  handleGameOverDismissed () {
    this.hud.enableBtns();
    this.mazeGame.resumeGame('same level');
  }

  handleGameComplete () {
    if (!gameData.gameComplete) {
      gameData.gameComplete = true;
      const gameCompletePopUp = new GameCompletePopup(this);
      this.add.existing(gameCompletePopUp);
      gameCompletePopUp.once('END_DIALOG', this.finishGame, this);
    }
  }

  cleanUp () {
    this.sound.stopAll();
    this.scene.start(SelectScreen.KEY);
  }

  update () {
    this.mazeGame.tick();
  }
}